import {
  ref as e,
  onMounted as t,
  onBeforeUnmount as r,
  watch as a,
  computed as n,
  unref as o,
  defineComponent as i,
  resolveComponent as l,
  openBlock as p,
  createElementBlock as s,
  normalizeClass as u,
  renderSlot as c,
  createCommentVNode as d,
  createElementVNode as v,
  normalizeStyle as m,
  toDisplayString as b,
  createVNode as g,
  mergeProps as f,
  createBlock as _,
  createSlots as h,
  withCtx as y,
  withModifiers as w,
  renderList as x,
  normalizeProps as k,
  guardReactiveProps as C,
} from 'vue'
import { u as V } from './useForm.js'
import { V as $, b as z, a as I, c as S } from './index58.js'
import j from 'cleave.js'
import { g as B } from './color-config.js'
import { s as E } from './style-inject.es.js'
import { f as F, e as R } from './child-props.js'
import { omit as P } from 'lodash-es'

const L = {
  creditCard: { creditCard: !0 },
  date: { date: !0, datePattern: ['d', 'm', 'Y'] },
  time: { time: !0, timePattern: ['h', 'm'], timeFormat: '24' },
  numeral: { numeral: !0, numeralThousandsGroupStyle: 'thousand' },
}, A = {
  mask: { type: [String, Object], default: () => ({}) },
  returnRaw: { type: Boolean, default: !0 },
  modelValue: { type: String },
}, useCleave = (o, i, l) => {
  const p = e(), destroyCleave = () => {
    p.value && p.value.destroy()
  }, initCleave = () => {
    var e;
    (destroyCleave(), o.value) && (p.value = new j(o.value, 'string' == typeof (e = i.mask) ? L[e] ? { ...L[e] } : {} : { ...e }))
  }
  t((() => {
    initCleave()
  })), r((() => {
    destroyCleave()
  })), a((() => [o.value, i.mask]), (() => {
    initCleave()
  }))
  const s = n((() => p.value && i.returnRaw && i.modelValue === p.value.getRawValue() ? p.value.getFormattedValue() : i.modelValue))
  return {
    cleave: p, computedValue: s, onInput: e => {
      const t = e.target.value;
      ('string' === i.mask || Object.keys(i.mask).length) && p.value && (p.value.setRawValue(t), i.returnRaw) ? l('update:modelValue', p.value.getRawValue()) : l('update:modelValue', t)
    },
  }
}, useEmitProxy = e => ({
  createListeners: t => e.reduce(((e, r) => {
    return {
      ...e,
      [(a = r, `on${a.charAt(0)
        .toUpperCase() + a.slice(1)}`)]: (...e) => t(r, ...e),
    }
    var a
  }), {}), createEmits: () => e,
})
var H = i({
  components: { VaMessageList: $ },
  props: {
    ...V, ...z,
    label: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    outline: { type: Boolean, default: !1 },
    bordered: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
  },
  emits: ['click', 'click-prepend', 'click-append', 'click-prepend-inner', 'click-append-inner', 'click-icon'],
  setup (e) {
    const { createModifiersClasses: t } = (r = 'va-input', {
      createModifiersClasses: (e, t = []) => n((() => {
        const a = e()
        return [r, ...o(t), ...Object.keys(a).filter((e => a[e]))
          .map((e => `${r}--${e}`))]
      })),
    })
    var r
    const a = n((() => B(e.color)))
    return {
      wrapperClass: t((() => ({
        outline: e.outline,
        bordered: e.bordered,
        solid: !e.outline && !e.bordered,
        disabled: e.disabled,
        readonly: e.readonly,
        labeled: !!e.label,
        success: e.success,
        focused: e.focused,
        error: e.error,
      }))),
      colorComputed: a,
      borderColorComputed: n((() => e.focused ? a.value : void 0)),
      messagesColor: n((() => e.error ? 'danger' : e.success ? 'success' : '')),
      messagesComputed: n((() => e.error ? e.errorMessages : e.messages)),
      errorLimit: n((() => e.error ? e.errorCount : 99)),
    }
  },
})
const M = { class: 'va-input-wrapper__content' },
  N = { class: 'va-input__content-wrapper' },
  T = { class: 'va-input__content' },
  O = { key: 1, class: 'va-input__content__input' },
  Y = { class: 'va-input-wrapper__message-list-wrapper' }
E(':root{--va-input-color:var(--va-background,#f5f9fb);--va-input-text-color:var(--va-dark,#262824);--va-input-scroll-color:var(--va-divided,#e1e9f8);--va-input-bordered-color:var(--va-divided,#e1e9f8);--va-input-border-width:1px;--va-input-border-radius:4px;--va-input-min-height:36px;--va-input-cursor:text;--va-input-success-color:var(--va-success);--va-input-success-background:#f1f7ee;--va-input-error-color:var(--va-danger);--va-input-error-background:#fdefef;--va-input-content-horizontal-padding:12px;--va-input-content-items-gap:6px;--va-input-line-height:20px;--va-input-font-size:1rem;--va-input-font-weight:normal;--va-input-font-style:normal;--va-input-font-stretch:normal;--va-input-letter-spacing:normal;--va-input-placeholder-text-color:#bac2bb;--va-input-disabled-opacity:0.4;--va-input-container-label-max-width:calc(100% - 0.75rem);--va-input-container-label-color:#4ae387;--va-input-container-label-font-size:0.6rem;--va-input-container-label-letter-spacing:0.0375rem;--va-input-container-label-line-height:1.2;--va-input-container-label-font-weight:700;--va-input-container-label-text-transform:uppercase;--va-input-container-label-transform-origin:top left}.va-input{align-items:center;color:var(--va-input-text-color);cursor:var(--va-input-cursor);display:flex;font-family:var(--va-font-family);position:relative}.va-input--readonly{cursor:default}.va-input--disabled{cursor:default;opacity:.4;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.va-input__container{align-items:center;border:var(--va-input-border-width) solid var(--va-input-color);display:flex;min-height:var(--va-input-min-height);overflow:hidden;padding:0 var(--va-input-content-horizontal-padding);position:relative;width:100%}.va-input__container>*{line-height:0;padding-right:var(--va-input-content-items-gap)}.va-input__container>:last-child{padding-right:0}.va-input-wrapper__content{flex-grow:1;position:relative}.va-input-wrapper__append-inner,.va-input-wrapper__prepend-inner,.va-input__append-inner,.va-input__prepend-inner{align-content:center;display:flex;justify-content:center}.va-input__content-wrapper{align-items:center;display:flex;width:100%}.va-input__content-wrapper .va-input__content{position:relative;width:100%}.va-input__content-wrapper .va-input__content input{cursor:inherit}.va-input__content-wrapper .va-input__content__input{background-color:transparent;border-style:none;color:var(--va-input-text-color);font-family:inherit;font-size:var(--va-input-font-size);font-stretch:var(--va-input-font-stretch);font-style:var(--va-input-font-style);font-weight:var(--va-input-font-weight);letter-spacing:var(--va-input-letter-spacing);line-height:var(--va-input-line-height);min-height:var(--va-input-line-height);outline:none;scrollbar-color:var(--va-input-scroll-color) transparent;scrollbar-width:thin;transform:translateY(-1px);width:100%}.va-input__content-wrapper .va-input__content__input::-webkit-scrollbar{width:4px}.va-input__content-wrapper .va-input__content__input::-webkit-scrollbar-track{border-radius:10px;box-shadow:none}.va-input__content-wrapper .va-input__content__input::-webkit-scrollbar-thumb{background:var(--va-input-scroll-color);border-radius:2px;opacity:.3}.va-input__content-wrapper .va-input__content__input::-moz-placeholder{color:var(--va-input-placeholder-text-color)}.va-input__content-wrapper .va-input__content__input:-ms-input-placeholder{color:var(--va-input-placeholder-text-color)}.va-input__content-wrapper .va-input__content__input::placeholder{color:var(--va-input-placeholder-text-color)}.va-input__content-wrapper .va-input__content__input:disabled{opacity:var(--va-input-disabled-opacity)}.va-input__icons{align-items:center;display:flex;justify-content:center}.va-input__icons>*{margin-right:calc(var(--va-input-content-items-gap)/4)}.va-input__icons>:last-child{margin-right:0}.va-input textarea{margin:12px 0;resize:vertical}.va-input--labeled .va-input__content-wrapper{align-items:flex-end;height:100%;padding-top:12px}.va-input--labeled .va-input__label{color:var(--va-input-container-label-color);display:block;font-size:var(--va-input-container-label-font-size);font-weight:var(--va-input-container-label-font-weight);height:12px;left:0;letter-spacing:var(--va-input-container-label-letter-spacing,var(--va-letter-spacing));line-height:var(--va-input-container-label-line-height);max-width:var(--va-input-container-label-max-width);overflow:hidden;padding-top:1px;position:absolute;text-overflow:ellipsis;text-transform:var(--va-input-container-label-text-transform);top:0;transform:translateY(-100%);transform-origin:top left;white-space:nowrap}.va-input--labeled textarea{margin-top:0}.va-input--solid .va-input__container{background:var(--va-input-color);border-color:var(--va-input-color);border-radius:var(--va-input-border-radius)}.va-input--solid.va-input--success .va-input__container{background:var(--va-input-success-background);border-color:var(--va-input-success-color)}.va-input--solid.va-input--error .va-input__container{background:var(--va-input-error-background);border-color:var(--va-input-error-color)}.va-input--outline .va-input__container{border-color:var(--va-input-bordered-color);border-radius:0}.va-input--outline.va-input--success .va-input__container{background:var(--va-input-success-background);border-color:var(--va-input-success-color)}.va-input--outline.va-input--error .va-input__container{background:var(--va-input-error-background);border-color:var(--va-input-error-color)}.va-input--bordered__border{border-bottom:var(--va-input-border-width) solid;border-color:var(--va-input-bordered-color);bottom:0;height:0;position:absolute;width:100%}.va-input--bordered .va-input__container{background:var(--va-input-color);border-color:transparent!important;border-top-left-radius:var(--va-input-border-radius);border-top-right-radius:var(--va-input-border-radius)}.va-input--bordered.va-input--success .va-input__container{background:var(--va-input-success-background)}.va-input--bordered.va-input--success .va-input_bordered__border{border-color:var(--va-input-success-color)}.va-input--bordered.va-input--error .va-input__container{background:var(--va-input-error-background)}.va-input--bordered.va-input--error .va-input_bordered__border{border-color:var(--va-input-error-color)}'), H.render = function render$2 (e, t, r, a, n, o) {
  const i = l('va-message-list')
  return p(), s('div', {
    class: u(['va-input-wrapper', e.wrapperClass]),
    onClick: t[5] || (t[5] = t => e.$emit('click', t)),
  }, [e.$slots.prepend ? (p(), s('div', {
    key: 0,
    class: 'va-input-wrapper__prepend-inner',
    onClick: t[0] || (t[0] = t => e.$emit('click-prepend')),
  }, [c(e.$slots, 'prepend')])) : d('v-if', !0), v('div', M, [v('div', {
    class: 'va-input__container',
    ref: 'container',
    style: m({ borderColor: e.borderColorComputed }),
  }, [e.$slots.prependInner ? (p(), s('div', {
    key: 0,
    class: 'va-input__prepend-inner',
    onClick: t[1] || (t[1] = t => e.$emit('click-prepend-inner', t)),
  }, [c(e.$slots, 'prependInner')])) : d('v-if', !0), v('div', N, [v('div', T, [e.label ? (p(), s('label', {
    key: 0,
    'aria-hidden': 'true',
    class: 'va-input__label',
    style: m({ color: e.colorComputed }),
  }, b(e.label), 5)) : d('v-if', !0), e.$slots.content ? (p(), s('div', O, [c(e.$slots, 'content')])) : d('v-if', !0), c(e.$slots, 'default')])]), e.$slots.icon ? (p(), s('div', {
    key: 1,
    class: 'va-input__icons',
    onClick: t[2] || (t[2] = t => e.$emit('click-icon', t)),
  }, [c(e.$slots, 'icon')])) : d('v-if', !0), e.$slots.appendInner ? (p(), s('div', {
    key: 2,
    class: 'va-input__append-inner',
    onClick: t[3] || (t[3] = t => e.$emit('click-append-inner', t)),
  }, [c(e.$slots, 'appendInner')])) : d('v-if', !0)], 4), e.bordered ? (p(), s('div', {
    key: 0,
    class: 'va-input--bordered__border',
    style: m({ borderColor: e.borderColorComputed }),
  }, null, 4)) : d('v-if', !0), v('div', Y, [g(i, {
    color: e.messagesColor,
    'model-value': e.messagesComputed,
    limit: e.errorLimit,
  }, null, 8, ['color', 'model-value', 'limit'])])]), e.$slots.append ? (p(), s('div', {
    key: 1,
    class: 'va-input-wrapper__append-inner',
    onClick: t[4] || (t[4] = t => e.$emit('click-append')),
  }, [c(e.$slots, 'append')])) : d('v-if', !0)], 2)
}, H.__file = 'src/components/va-input/components/VaInputField.vue'
const G = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing']
let U = null
const createHiddenTextarea = (e, t) => {
  U || (U = document.createElement('textarea')), U.setAttribute('style', t + '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\';\n'), U.value = e.value || e.placeholder || ''
  const r = e.getAttribute('wrap')
  return null !== r ? U.setAttribute('wrap', r) : U.removeAttribute('wrap'), U
}, useTextareaRowHeight = e => ({
  calculateRowHeight: () => {
    if (!e.value) return 0
    const { boxSizing: t, padding: r, border: a, styles: n } = (e => {
      const t = window.getComputedStyle(e)
      return {
        boxSizing: t.getPropertyValue('box-sizing') || t.getPropertyValue('-moz-box-sizing') || t.getPropertyValue('-webkit-box-sizing'),
        padding: parseFloat(t.getPropertyValue('padding-bottom')) + parseFloat(t.getPropertyValue('padding-top')),
        border: parseFloat(t.getPropertyValue('border-bottom-width')) + parseFloat(t.getPropertyValue('border-top-width')),
        styles: G.map((e => `${e}:${t.getPropertyValue(e)}`)).join(';') + ';',
      }
    })(e.value), o = createHiddenTextarea(e.value, n)
    document.body.appendChild(o)
    let i = o.scrollHeight
    return 'border-box' === t ? i += a : 'content-box' === t && (i -= r), document.body.removeChild(o), i
  },
}), positiveNumberValidator = e => {
  if (e > 0 && (0 | e) === e) return !0
  throw new Error(`\`minRows\` must be a positive integer greater than 0, but ${e} is provided`)
}, {
  createEmits: q,
  createListeners: D,
} = useEmitProxy(['input', 'change', 'click', 'update:modelValue'])
var J = i({
  props: {
    modelValue: { type: [String, Number], default: '' },
    autosize: { type: Boolean, default: !1 },
    minRows: { type: Number, default: 1, validator: positiveNumberValidator },
    maxRows: {
      type: Number,
      validator: positiveNumberValidator,
      default: 999999,
    },
  }, emits: q(), setup (r, { emit: o, expose: i }) {
    const l = e(), p = e(-1),
      s = e(-1), { calculateRowHeight: u } = useTextareaRowHeight(l),
      updateHeight = () => {
        var e
        r.autosize && l.value && (s.value = (null === (e = l.value) || void 0 === e ? void 0 : e.scrollHeight) || 0)
      }
    t((() => {
      r.autosize && l.value && (p.value = u()), updateHeight()
    })), a((() => r.modelValue), updateHeight)
    return i({
      focus: () => {
        var e
        null === (e = l.value) || void 0 === e || e.focus()
      }, blur: () => {
        var e
        null === (e = l.value) || void 0 === e || e.blur()
      },
    }), {
      textarea: l,
      computedHeight: n((() => ({
        minHeight: p.value * r.minRows + 'px',
        maxHeight: p.value * r.maxRows + 'px',
        height: s.value + 'px',
      }))),
      listeners: D(o),
    }
  }, methods: {
    focus () {
      var e
      null === (e = this.textarea) || void 0 === e || e.focus()
    }, blur () {
      var e
      null === (e = this.textarea) || void 0 === e || e.blur()
    },
  },
})
const K = ['value']
E('textarea{border:0;font-family:var(--va-font-family);padding:0}'), J.render = function render$1 (e, t, r, a, n, o) {
  return p(), s('textarea', f({ ref: 'textarea' }, e.listeners, {
    value: e.modelValue,
    style: { ...e.computedHeight },
  }), null, 16, K)
}, J.__file = 'src/components/va-input/components/VaTextarea/VaTextarea.vue'
const Q = R(J), {
  createEmits: W,
  createListeners: X,
} = useEmitProxy(['change', 'keyup', 'keypress', 'keydown', 'focus', 'blur']), {
  createEmits: Z,
  createListeners: ee,
} = useEmitProxy(['click', 'click-prepend', 'click-append', 'click-prepend-inner', 'click-append-inner', 'click-icon'])
var te = i({
  components: { VaInputField: H, VaTextarea: J },
  props: {
    ...V, ...z, ...A, ...Q,
    placeholder: { type: String, default: '' },
    clearable: { type: Boolean, default: !1 },
    clearableIcon: { type: String, default: 'highlight_off' },
    tabindex: { type: Number, default: 0 },
    modelValue: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    loading: { type: Boolean, default: !1 },
    color: { tpe: String, default: 'primary' },
    outline: { type: Boolean, default: !1 },
    bordered: { type: Boolean, default: !1 },
  },
  emits: ['update:modelValue', ...I, ...W(), ...Z()],
  inheritAttrs: !1,
  setup (t, { emit: r, attrs: a, expose: o }) {
    const i = e(), reset = () => {
        r('update:modelValue', ''), r('cleared')
      }, focus = () => {
        var e
        null === (e = i.value) || void 0 === e || e.focus()
      }, blur = () => {
        var e
        null === (e = i.value) || void 0 === e || e.blur()
      }, {
        isFocused: l,
        listeners: p,
        computedError: s,
        computedErrorMessages: u,
      } = S(t, r, (() => reset()), (() => focus()), (() => blur())),
      c = n((() => t.clearable && ![null, void 0, ''].includes(t.modelValue))),
      d = n((() => l.value ? t.color : s.value ? 'danger' : t.success ? 'success' : 'grey')),
      v = n((() => 'textarea' === t.type ? void 0 : i.value)), {
        computedValue: m,
        onInput: b,
      } = useCleave(v, t, r), g = n((() => ({
        ...P(a, ['class', 'style']), ...X(r), ...p,
        value: m.value,
        type: t.type,
        tabindex: t.tabindex,
        disabled: t.disabled,
        readonly: t.readonly,
        placeholder: t.placeholder,
        ariaLabel: t.label,
      })))
    return o({ reset: reset, focus: focus, blur: blur }), {
      input: i,
      textareaProps: F(t, Q),
      computedError: s,
      computedErrorMessages: u,
      isFocused: l,
      onInput: b,
      canBeCleared: c,
      clearIconColor: d,
      computedInputAttributes: g,
      fieldListeners: ee(r),
      reset: reset,
    }
  },
  methods: {
    focus () {
      var e
      null === (e = this.input) || void 0 === e || e.focus()
    }, blur () {
      var e
      null === (e = this.input) || void 0 === e || e.blur()
    },
  },
})
te.render = function render (e, t, r, a, n, o) {
  const i = l('va-icon'), u = l('VaTextarea'), v = l('VaInputField')
  return p(), _(v, f(e.fieldListeners, {
    class: e.$attrs.class,
    style: e.$attrs.style,
    color: e.color,
    readonly: e.readonly,
    disabled: e.disabled,
    success: e.success,
    messages: e.messages,
    error: e.computedError,
    'error-messages': e.computedErrorMessages,
    'error-count': e.errorCount,
    label: e.label,
    bordered: e.bordered,
    outline: e.outline,
    focused: e.isFocused,
    onClick: t[2] || (t[2] = t => e.input && e.input.focus()),
  }), h({
    icon: y((() => [e.success ? (p(), _(i, {
      key: 0,
      color: 'success',
      name: 'check_circle',
      size: 'small',
    })) : d('v-if', !0), e.computedError ? (p(), _(i, {
      key: 1,
      color: 'danger',
      name: 'warning',
      size: 'small',
    })) : d('v-if', !0), e.canBeCleared ? (p(), _(i, {
      key: 2,
      color: e.clearIconColor,
      name: e.clearableIcon,
      size: 'small',
      onClick: t[0] || (t[0] = w((t => e.reset()), ['stop'])),
    }, null, 8, ['color', 'name'])) : d('v-if', !0), e.loading ? (p(), _(i, {
      key: 3,
      color: e.color,
      name: 'loop',
      size: 'small',
      spin: 'counter-clockwise',
    }, null, 8, ['color'])) : d('v-if', !0)])),
    default: y((() => ['textarea' === e.type ? (p(), _(u, f({
      key: 0,
      ref: 'input',
    }, e.textareaProps, {
      class: 'va-input__content__input',
      onInput: e.onInput,
    }), null, 16, ['onInput'])) : (p(), s('input', f({
      key: 1,
      ref: 'input',
    }, e.computedInputAttributes, {
      class: 'va-input__content__input',
      onInput: t[1] || (t[1] = (...t) => e.onInput && e.onInput(...t)),
    }), null, 16))])),
    _: 2,
  }, [x(e.$slots, ((t, r) => ({
    name: r,
    fn: y((t => [c(e.$slots, r, k(C(t)))])),
  })))]), 1040, ['class', 'style', 'color', 'readonly', 'disabled', 'success', 'messages', 'error', 'error-messages', 'error-count', 'label', 'bordered', 'outline', 'focused'])
}, te.__file = 'src/components/va-input/VaInput.vue'
export { te as s }
//# sourceMappingURL=VaInput.js.map
